import {Component} from '@angular/core';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.css']
})
export class ImageSliderComponent {
	
	constructor() {
		
	}

  ngOnInit() {
  }
  

}



// WEBPACK FOOTER //
// /app/src/app/event/image-slider/image-slider.component.ts